<div class="map-md-card">
  <h2>City of Raleigh Public Utilities Department</h2>
</div>

<mat-card class="shipping-card">
  <mat-card-header>
    <mat-card-title>
      <h1>Inspection Request</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <p>
      Use this form to schedule water and wastewater infrastructure inspections for development
      projects in Garner, Knightdale, Rolesville, Wake Forest, Wendell, and Zebulon.
    </p>

    <form [formGroup]="addressForm" (ngSubmit)="onSubmit()" novalidate>

      <!-- Project Information -->
      <mat-card class="shipping-card">
        <mat-card-title>Project Information</mat-card-title>
        <mat-card-content>
          <p>Select the town where the work will take place.</p>
          <p><em>(If you need to request an inspection in Raleigh please contact 919-996-2495)</em></p>

          <mat-form-field class="full-width">
            <mat-label>Town</mat-label>
            <mat-select formControlName="town">
              <mat-option *ngFor="let town of towns" [value]="town">{{ town }}</mat-option>
            </mat-select>
            <mat-error *ngIf="addressForm.get('town').hasError('required')">
              Township is <strong>required</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field class="full-width">
            <mat-label>Project name</mat-label>
            <input matInput formControlName="project" placeholder="Enter the name of the project" />
            <mat-error *ngIf="addressForm.get('project').hasError('required')">
              Project Name is <strong>required</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field class="full-width">
            <mat-label>Project location</mat-label>
            <input matInput formControlName="location" placeholder="Address or project location description" />
            <mat-error *ngIf="addressForm.get('location').hasError('required')">
              Location is <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </mat-card-content>
      </mat-card>

      <!-- Contractor Contact Information -->
      <mat-card class="shipping-card">
        <mat-card-title>Contractor Contact Information</mat-card-title>
        <mat-card-content>
          <div class="row">
            <div class="col">
              <mat-form-field class="full-width">
                <mat-label>First name</mat-label>
                <input matInput formControlName="firstName" />
                <mat-error *ngIf="addressForm.get('firstName').hasError('required')">
                  First name is <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field class="full-width">
                <mat-label>Last name</mat-label>
                <input matInput formControlName="lastName" />
                <mat-error *ngIf="addressForm.get('lastName').hasError('required')">
                  Last name is <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <mat-form-field class="full-width">
            <mat-label>Email Address</mat-label>
            <input matInput formControlName="email" type="email" />
          </mat-form-field>

          <mat-form-field class="full-width">
            <mat-label>Company Name</mat-label>
            <input matInput formControlName="company" />
            <mat-error *ngIf="addressForm.get('company').hasError('required')">
              Company is <strong>required</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field class="full-width">
            <mat-label>Phone Number</mat-label>
            <input matInput formControlName="phone" placeholder="(919) 555-1234" />
            <mat-error *ngIf="addressForm.get('phone').hasError('required')">
              Phone Number is <strong>required</strong>
            </mat-error>
            <mat-error *ngIf="addressForm.get('phone').hasError('pattern')">
              Please enter a <strong>valid</strong> phone number
            </mat-error>
          </mat-form-field>
        </mat-card-content>
      </mat-card>

      <!-- General Inspection Information -->
      <mat-card class="shipping-card">
        <mat-card-title>General Inspection Information</mat-card-title>
        <mat-card-content>
          <mat-form-field class="half-width">
            <mat-label>Choose date</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="inspdate" [min]="minDate" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="addressForm.get('inspdate').hasError('required')">
              Inspection Date is <strong>required</strong>
            </mat-error>
          </mat-form-field>

          <p>In the sections below, select any and all options that apply</p>

          <div formGroupName="checkboxes">
            <div *ngFor="let type of inspectionTypes">
              <div class="chksection">
                <mat-checkbox [formControlName]="type.name">{{ type.name }}</mat-checkbox>
              </div>
              <div *ngIf="type.note" class="checkbox-note">{{ type.note }}</div>
            </div>
          </div>

          <mat-form-field class="full-width" style="margin-top: 16px;">
            <mat-label>Customer Notes</mat-label>
            <textarea matInput formControlName="notes" rows="4"></textarea>
          </mat-form-field>
        </mat-card-content>

        <mat-card-actions>
          <button
            mat-raised-button
            color="primary"
            type="submit"
            [disabled]="inProgress"
          >
            <mat-spinner *ngIf="inProgress" diameter="20" style="display:inline-block; margin-right:8px;"></mat-spinner>
            Submit your selections
          </button>
        </mat-card-actions>
      </mat-card>

    </form>

    <!-- Success message -->
    <div *ngIf="submitted" class="success-message shipping-card">
      Your inspection request has been submitted. Your Service Request ID is <strong>{{ reqid }}</strong>.
    </div>

    <!-- Error message -->
    <div *ngIf="error" style="color:red;" class="shipping-card">
      {{ error }}
    </div>

  </mat-card-content>
</mat-card>

<!-- Check Status Section -->
<mat-card class="shipping-card status-section">
  <mat-card-title>Check status of existing request</mat-card-title>
  <mat-card-content>
    <form [formGroup]="chkReqId" (ngSubmit)="onSubmitStatusChk()" novalidate>
      <div class="row">
        <div class="col">
          <mat-form-field class="half-width">
            <mat-label>Service Request ID</mat-label>
            <input matInput formControlName="reqid" />
            <mat-error *ngIf="chkReqId.get('reqid').hasError('required')">
              Service Request ID is <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <button
        mat-raised-button
        color="accent"
        type="submit"
        [disabled]="inStatusChkProgress"
      >
        <mat-spinner *ngIf="inStatusChkProgress" diameter="20" style="display:inline-block; margin-right:8px;"></mat-spinner>
        Check Status
      </button>
    </form>

    <div *ngIf="statusMessage" class="status-result">
      {{ statusMessage }}
    </div>
  </mat-card-content>
</mat-card>
